import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { ReferralType } from '@wix/da-bi/pkg/constants';
import { DeviationResourceType, DeviationTypes } from '../../types/deviation';
import ConfirmationModal from '../../Popup/ConfirmationModal';
import { URLS } from '@wix/da-url';
import s from './UnsubscribePopup.scss';
import { BiData } from '@wix/da-bi/pkg/events';
export const UnsubscribePopup = ({ deviation, onUnsubscribe, close })=>{
    var _deviation_tier;
    const { t } = useTranslation();
    if (deviation.type !== DeviationTypes.TIER) {
        return null;
    }
    const content = /*#__PURE__*/ React.createElement("div", {
        className: s['content']
    }, /*#__PURE__*/ React.createElement("p", null, /*#__PURE__*/ React.createElement(Trans, {
        i18nKey: "deviation.tier.unsubPopup.confirm.body",
        values: {
            tierName: deviation.title
        }
    })), /*#__PURE__*/ React.createElement("ul", {
        className: s['benefits']
    }, (((_deviation_tier = deviation.tier) === null || _deviation_tier === void 0 ? void 0 : _deviation_tier.benefits) || []).map((benefit, idx)=>/*#__PURE__*/ React.createElement("li", {
            key: `benefit-${idx}`
        }, benefit))));
    return /*#__PURE__*/ React.createElement(ConfirmationModal, {
        isOpen: true,
        title: t('deviation.tier.unsubPopup.confirm.title'),
        text: content,
        confirmBtnType: "danger",
        confirmBtnLabel: t('deviation.tier.unsubPopup.confirm.accept'),
        confirmBtnBiData: BiData({
            evid: 552,
            typeid: DeviationResourceType.TIER,
            itemid: deviation.deviationId,
            referral_info: typeof window !== 'undefined' && window.location.href === URLS.ORDERS ? ReferralType.BILLING_PAYMENTS : ReferralType.TIER_CARD
        }),
        cancelBtnLabel: t('deviation.tier.unsubPopup.confirm.cancel'),
        onCancel: close,
        onConfirm: ()=>{
            onUnsubscribe(deviation);
        }
    });
};
UnsubscribePopup.displayName = 'UnsubscribePopup';
export default UnsubscribePopup;

//# sourceMappingURL=UnsubscribePopup.js.map